<template>
  <el-dialog title="设为组长" :visible.sync="postInfo.show" width="500px">
    <el-form ref="lForm" :model="lObject" size="small" :rules="rules">
      <el-row>
        <el-col>
          <el-form-item prop="classPost">
            <el-select
              class="select-content"
              v-model="lObject.classPost"
              placeholder="请选择班内职务"
            >
              <el-option
                v-for="(item, i) in postTypeList"
                :key="i"
                :label="item.paramValue"
                :value="item.paramKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="handleClose" title="取消"></butn>
      <butn btntype="primary" @click="submitForm" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import { getDataMap } from "@/api/sysParam";
import butn from "@/components/button/index";

export default {
  components: { butn },
  name: "editPost",
  props: {
    postInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      lObject: {
        classPost: "",
        uuid: "",
      },
      rules: {
        classPost: [
          {
            required: true,
            message: "请输入班内职务",
            trigger: ["change", "blur"],
          },
        ],
      },
      postTypeList: [],
    };
  },
  created() {
    getDataMap("CLASS_POST_TYPE").then((res) => {
      if (!res || res.code != 0) return;
      this.postTypeList = res.data.slice(-3);
    });
  },
  methods: {
    handleClose() {
      this.$refs["lForm"].resetFields();
      this.$emit("closePost");
    },
    submitForm() {
      this.$refs["lForm"].validate((valid) => {
        if (valid) {
          this.$emit("changePost", this.lObject.classPost);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.select-content {
  width: 100% !important;
}
</style>
